module.exports = __webpack_public_path__ + "img/empty.8bad4f5b.png";